import type { IconProps } from "./types";

const defaultProps = {
  svgProps: {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    focusable: false,
    "aria-hidden": true,
  },
  pathProps: {
    fill: "currentColor",
  },
};

const ChatBubble = ({
  svgProps = defaultProps.svgProps,
  pathProps = defaultProps.pathProps,
}: IconProps) => {
  const mergedSvgProps = { ...defaultProps.svgProps, ...svgProps };
  const mergedPathProps = { ...defaultProps.pathProps, ...pathProps };
  return (
    <svg {...mergedSvgProps}>
      <path
        d="M67.6502 33.8251C67.6502 15.144 52.5062 0 33.8251 0C15.144 0 0 15.144 0 33.8251C0 52.5062 15.144 67.6502 33.8251 67.6502C52.5062 67.6502 67.6502 52.5062 67.6502 33.8251Z"
        {...mergedPathProps}
      />
    </svg>
  );
};

export default ChatBubble;
